import { useRef } from 'react';
import { FormGenerator } from "formik-generator-materialui";
import Button from '@material-ui/core/Button';
import useBatchFormData from '../../hooks/use-batch-form-data';
import { BATCH_FORM_NAMES as FORM_NAMES } from '../../hooks/constants';

const formFieldsSchema = [
    {
        title: 'Room #',
        typeField: 'text',
        path: 'roomNum'
    },
    {
        title: 'Operational Parameters',
        typeField: 'group',
        path: 'operationalParameters',
        subfields: [
            {
                title: 'Speed (CPM)',
                typeField: 'text',
                path: 'operationalParameters/speedCpm',
                col: 3
            },
            {
                title: 'Seal Temp',
                typeField: 'text',
                path: 'operationalParameters/sealTemp',
                col: 3
            },
            {
                title: 'Form Temp',
                typeField: 'text',
                path: 'operationalParameters/formTemp',
                col: 3
            },
            {
                title: '% Relative Humidity (NMT)',
                typeField: 'text',
                path: 'operationalParameters/relativeHumidity',
                col: 3
            }
        ]
    },
    {
        title: 'Inspection Results',
        typeField: 'arrayObject',
        path: "inspectionResults",
        emptyAddText: 'Add Row',
        subfields: [
            {
                title: 'Date',
                typeField: 'date',
                name: 'date',
                simple: true,
                col: 3
            },
            {
                title: 'Opening Features',
                typeField: 'text',
                name: 'openingFeatures',
                col: 3
            },
            {
                title: 'Vision',
                typeField: 'text',
                name: 'vision',
                col: 3
            },
            {
                title: 'Seal Leak',
                typeField: 'text',
                name: 'sealLeak',
                col: 3
            },
            {
                title: 'Label',
                typeField: 'text',
                name: 'label',
                col: 3
            },
            {
                title: 'Case #',
                typeField: 'text',
                name: 'caseNum',
                col: 3
            },
            {
                title: 'Seal (℃)',
                typeField: 'text',
                name: 'seal',
                col: 3
            },
            {
                title: 'Speed CPM',
                typeField: 'text',
                name: 'speedCpm',
                col: 3
            },
            {
                title: 'Form (℃)',
                typeField: 'text',
                name: 'form',
                col: 3
            },
            {
                title: '%RH',
                typeField: 'text',
                name: 'rh',
                col: 3
            }
        ]
    }
];

const prepareDataToEdit = (values) => {
    const data = Object.assign({}, values);
    return data;
}

function QAInspectionForm({
    orderId,
    lotId,
    onSave = null,
    onCancel = null,
    isReadOnly = false,
    isValidateOnlyOnSubmit = true
}) {
    const { batchFormData, saveBatchForm, error } = useBatchFormData(orderId, lotId, FORM_NAMES.qaInspection);
    let initialValues = {};
    if (batchFormData) {
        initialValues = prepareDataToEdit(batchFormData);
    }

    const saveFormData = (formData) => {
        saveBatchForm(formData).then(() => {
            onSave && onSave();
        });
    };

    const formRef = useRef(null);
    return (
        <>
            <FormGenerator
              onSubmit={(values) => {
                saveFormData(values);
              }}
              fields={formFieldsSchema}
              formRef={formRef}
              initialValues={initialValues}
              readOnly={isReadOnly}
              isValidateOnlyOnSubmit={isValidateOnlyOnSubmit}
            />
            <Button color="secondary" style={{ marginRight: '2em' }}
                onClick={() => {
                    formRef.current.resetForm();
                    onCancel && onCancel();
                }}>Cancel</Button>
            <Button variant="contained" color="primary"
                onClick={() => formRef.current.submitForm()}>Save</Button>
        </>
    );
}

export default QAInspectionForm;